/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Youtube_Export_UploadingInputs */

const cs_youtube_export_uploading = /** @type {(inputs: Youtube_Export_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nahrávání… ${i?.percent} %`)
};

const en_youtube_export_uploading = /** @type {(inputs: Youtube_Export_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading… ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Uploading… {percent}%" |
*
* @param {Youtube_Export_UploadingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_uploading = /** @type {((inputs: Youtube_Export_UploadingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_UploadingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_uploading(inputs)
	return cs_youtube_export_uploading(inputs)
});